export default __webpack_public_path__ + "static/media/ps1.25d8f8c4.svg";